import { render, staticRenderFns } from "./ArticleCompanyCreate.vue?vue&type=template&id=33bd0e12&"
import script from "./ArticleCompanyCreate.vue?vue&type=script&lang=js&"
export * from "./ArticleCompanyCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports